import React from 'react';
import {Image, StyleProp, View, ViewStyle} from 'react-native';
import {StyleSheet} from 'react-native';

import config from '../../../config';
import {Brand} from '../../../config';
import onDark from '../../../images/brand/rewards/on-dark.png';
import onLight from '../../../images/brand/rewards/on-light.png';
import PasswordIcon from '../../../images/brand/svg/icons/Password.svg';

export const styles = StyleSheet.create({
  svgContainer: {
    marginVertical: 30,
    paddingTop: 16,
    alignSelf: 'center',
  },
  rewardsImage: {
    marginVertical: 30,
    height: 65.46,
    width: 109.06,
    alignSelf: 'center',
  },
  rewardsSquareImage: {
    marginVertical: 30,
    height: 75,
    width: 75,
    alignSelf: 'center',
  },
});

type RewardsProgramImageProps = {
  variant: 'onDark' | 'onLight' | 'password';
  style?: StyleProp<ViewStyle>;
};

export default function RewardsProgramImage({variant, style}: RewardsProgramImageProps) {
  const variants = {onDark, onLight};
  const brand = config.BASE_TENANT;
  const useSquareImage = brand === Brand.THIRSTY_CAMEL;

  return variant === 'password' ? (
    <View style={styles.svgContainer} testID="password-icon-container">
      <PasswordIcon width={61} height={61} />
    </View>
  ) : (
    <Image
      testID="program-image"
      source={variants[variant]}
      style={[useSquareImage ? styles.rewardsSquareImage : styles.rewardsImage, style]}
    />
  );
}
